import { ApplicationState } from 'application/redux';
import { sideMenuClearCache } from 'core/side-menu/redux/action';
import { connect } from 'react-redux';
import { calls, fetchShadow } from '../general/redux/actions';
import { fetchAssetValues, setFields } from './redux/actions';
import SettingsComponent from './settings-component';

const mapStateToProps = (state: ApplicationState) => ({
  general: state.devices.detail.general,
  settings: state.devices.detail._settings,
  sideMenu: state.sideMenu,
  t: state.i18n.t
});

export default connect(mapStateToProps, {
  fetchAssetValues,
  setFields,
  fetchShadow,
  sideMenuClearCache,
  calls
})(SettingsComponent);
